import React, {useEffect, useState} from "react";

import './users-devices-table.scss'
import {useRecoilValue} from "recoil";
import {grpcUserServiceSelector} from "../../state/grpc";
import {
  DataTable,
  DataTableSkeleton,
  OverflowMenu,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableHeader,
  TableRow,
  TableToolbar,
  TableToolbarContent,
  TableToolbarSearch
} from "@carbon/react";
import {TrashCan} from "@carbon/react/icons";
import {ADD, useToastContext} from "../Toast";
import ConfirmDialog from "../ConfirmDialog";

const UsersDevicesTable = ({}) => {
  const headers = [{
    key: 'id', header: 'ID'
  }, {
    key: 'username', header: 'Username'
  }, {
    key: 'label', header: 'Dispositivo'
  }, {
    key: 'registeredAt', header: 'Registrato il'
  }];

  const {toastDispatch} = useToastContext();
  const userService = useRecoilValue(grpcUserServiceSelector)
  const [loading, setLoading] = useState(true)
  const [devices, setDevices] = useState([])
  const [error, setError] = useState(false)
  const [deleteModalOpen, setDeleteModalOpen] = useState(false)
  const [deleteModalId, setDeleteModalId] = useState()

  async function getUserDevices() {
    const req = new proto.api.ListUserDevicesRequest()
    req.setShowOnlyMine(false) // todo
    userService.listDevices(req, null, (err, resp) => {
      if (err != null) {
        console.error(err)
        setError(true)
      } else {
        setDevices(resp.toObject().userdevicesList)
      }
      setLoading(false)
    })
  }

  useEffect(() => {
    getUserDevices()
  }, []);

  if (loading) {
    return (<DataTableSkeleton
      columnCount={4}
      rowCount={5}
    />)
  }

  if (error) {
    return (<div>
      <span>ERROR!</span>
    </div>)
  }

  return (<DataTable
    rows={devices}
    headers={headers}
    isSortable
    overflowMenuOnHover={false}
    render={({
               rows,
               headers,
               getHeaderProps,
               getRowProps,
               getToolbarProps,
               onInputChange,
               getTableProps,
               getTableContainerProps,
             }) => {
      return (
        <TableContainer title="Dispositivi utente"
                        description="Lista dei dispositivi utente registrati" {...getTableContainerProps()}>
          <ConfirmDialog
            openState={deleteModalOpen}
            setOpenState={setDeleteModalOpen}
            heading={"Sei sicuro di voler eliminare il dispositivo?"}
            primaryButtonText="Elimina"
            onRequestSubmit={() => {
              const req = new proto.api.UnregisterDeviceRequest()
              req.setId(deleteModalId)
              userService.unregisterDevice(req, null, (err, resp) => {
                if (err != null) {
                  console.error(err)
                  toastDispatch({
                    type: ADD,
                    payload: {
                      title: "Operazione fallita",
                      content: "Impossibile eliminare il dispositivo",
                      kind: "error",
                      caption: err.message
                    }
                  })
                } else {
                  getUserDevices()
                  setDeleteModalOpen(false)
                  toastDispatch({
                    type: ADD,
                    payload: {
                      title: "Operazione avvenuta con successo",
                      content: "Dispositivo utente eliminato con successo",
                      kind: "success"
                    }
                  })
                }
              })
            }}
          />
          <TableToolbar {...getToolbarProps()} >
            <TableToolbarContent>
              <TableToolbarSearch onChange={onInputChange} size="lg"/>
            </TableToolbarContent>
          </TableToolbar>
          <Table {...getTableProps()}>
            <TableHead>
              <TableRow>
                {headers.map((header) => (<TableHeader {...getHeaderProps({header})}>
                  {header.header}
                </TableHeader>))}
                <TableHeader scope="col"/>
              </TableRow>
            </TableHead>
            <TableBody>
              {rows.map((row) => (
                <TableRow key={row.id} {...getRowProps({row})}>
                  {row.cells.map((cell) => (
                    <TableCell key={cell.id}>
                      {cell.value}
                    </TableCell>
                  ))}
                  <TableCell className="cds--table-column-menu">
                    <OverflowMenu
                      flipped size='md' aria-label="Elimina"
                      iconDescription="Elimina"
                      renderIcon={TrashCan}
                      onClick={() => {
                        setDeleteModalId(row.id)
                        setDeleteModalOpen(true)
                      }}/>
                  </TableCell>
                </TableRow>))}
            </TableBody>
          </Table>
        </TableContainer>);
    }}
  />)
}

export default UsersDevicesTable